import { Outlet } from "react-router-dom";
import { LiveChatWidget } from "@livechat/widget-react";
import { Root, SideNav } from "./components";
import { useIsMobile } from "../../../../helpers/ui";
import useGetMe from "../../../../hooks/queries/useGetMe";
import { useStoreActions, useStoreState } from "../../../../store";

const EmployeeDashboard = () => {
  const { data } = useGetMe();
  const livechatState = useStoreState((state) => state.livechat);
  const livechatActions = useStoreActions((actions) => actions.livechat);
  const isMobile = useIsMobile();

  return (
    <Root>
      <div className={`${!isMobile ? "flex overflow-hidden" : ""} h-100`}>
        {!isMobile && (
          <div className="flex">
            <SideNav />
          </div>
        )}
        <div className={`flex flex-1 h-100 ${!isMobile && "overflow-y-auto"}`}>
          <Outlet />
        </div>
      </div>
      {data && (
        <LiveChatWidget
          // @ts-ignore
          license={process.env.REACT_APP_LIVECHAT_LICENSE}
          group={process.env.REACT_APP_LIVECHAT_GROUP}
          customerEmail={data.user.email}
          customName={`${data.user.first_name} ${data.user.last_name}`}
          visibility={livechatState.visibility}
          onVisibilityChanged={(visibility) =>
            livechatActions.setVisibility(visibility.visibility)
          }
        />
      )}
    </Root>
  );
};

export default EmployeeDashboard;
